import React from 'react';

export const CheckIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="43"
      viewBox="0 0 44 43"
      fill="none"
      className={className}
    >
      <path
        d="M33.9502 0H10.0502C4.87016 0 0.660156 4.21 0.660156 9.39V33.29C0.660156 38.47 4.87016 42.68 10.0502 42.68H33.9502C39.1302 42.68 43.3402 38.47 43.3402 33.29V9.39C43.3402 4.21 39.1302 0 33.9502 0ZM32.5902 15.2L20.9902 30.56C20.5502 31.14 19.8902 31.5 19.1702 31.57C19.1002 31.57 19.0202 31.58 18.9502 31.58C18.3002 31.58 17.6802 31.34 17.2102 30.89L11.7202 25.77C10.6902 24.8 10.6302 23.19 11.5902 22.15C12.5602 21.12 14.1802 21.06 15.2102 22.02L18.6302 25.21L28.5202 12.11C29.3702 10.98 30.9702 10.76 32.1102 11.61C33.2402 12.46 33.4602 14.07 32.6102 15.2H32.5902Z"
        fill="#03BF9E"
      />
    </svg>
  );
};
